import { Calendar, Lock } from "lucide-react";

export default function RouteInventory({ inventory, onReserve }) {
  return (
    <section className="max-w-7xl mx-auto px-6 md:px-8 py-16" data-testid="route-inventory">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-8">
        <div>
          <div className="overline">Route inventory · Live</div>
          <h2 className="font-display text-4xl md:text-5xl uppercase mt-3 drip-shadow">
            What's left on the route
          </h2>
          <p className="text-white/70 mt-3 max-w-xl text-sm">
            Real-time sponsorship availability across the next 10 stops. Pink = open. Gold =
            taken. Reserve a city below, custom dates always negotiable.
          </p>
        </div>
        <div className="flex gap-4 text-[10px] tracking-[0.25em] uppercase font-mono-tactical">
          <span className="flex items-center gap-2 text-[#FF1493]">
            <span className="w-3 h-3 bg-[#FF1493]" /> Available
          </span>
          <span className="flex items-center gap-2 text-white/80">
            <span className="w-3 h-3 border border-white/40" /> In talks
          </span>
          <span className="flex items-center gap-2 text-[#FFC107]">
            <span className="w-3 h-3 bg-[#FFC107]" /> Sold
          </span>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {inventory.map((slot) => {
          const isAvailable = slot.status === "available";
          const isSold = slot.status === "sold";
          const dt = new Date(slot.scheduled_date);
          return (
            <article
              key={slot.id}
              className={`tac-card p-5 flex flex-col gap-2 relative ${
                isAvailable ? "" : isSold ? "opacity-90" : "opacity-80"
              }`}
              style={{
                borderColor: isAvailable
                  ? "rgba(255, 20, 147, 0.5)"
                  : isSold
                  ? "rgba(255, 193, 7, 0.5)"
                  : "rgba(255,255,255,0.18)",
              }}
              data-testid={`slot-${slot.city.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="flex items-center justify-between">
                <span
                  className="text-[10px] tracking-[0.25em] uppercase font-display"
                  style={{
                    color: isAvailable ? "#FF1493" : isSold ? "#FFC107" : "rgba(255,255,255,0.7)",
                  }}
                >
                  {isAvailable ? "Open" : isSold ? "Sold" : "In talks"}
                </span>
                <span className="font-mono-tactical text-[10px] text-white/40 flex items-center gap-1">
                  <Calendar size={9} />
                  {dt.toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                </span>
              </div>
              <div>
                <div className="font-display text-2xl uppercase leading-none">{slot.city}</div>
                <div className="text-[10px] tracking-[0.2em] uppercase text-white/50 font-mono-tactical mt-1">
                  {slot.state}
                </div>
              </div>
              <div className="text-xs text-white/65 mt-1">{slot.tier}</div>
              <div className="font-display text-xl text-white">
                ${slot.price.toLocaleString()}
              </div>
              {isSold || slot.status === "in_talks" ? (
                <div className="mt-1 flex items-center gap-1 text-[11px]">
                  <Lock size={10} className={isSold ? "text-[#FFC107]" : "text-white/50"} />
                  <span className="text-white/70 truncate">{slot.sponsor_name}</span>
                </div>
              ) : (
                <button
                  onClick={() => onReserve(slot)}
                  className="btn-blaze mt-2 text-[10px] px-3 py-2 justify-center"
                  data-testid={`reserve-${slot.city.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {slot.tier === "City Feature" ? "Buy now" : "Reserve"}
                </button>
              )}
            </article>
          );
        })}
      </div>

      <div className="mt-6 text-xs font-mono-tactical text-white/50 uppercase tracking-[0.2em] flex flex-wrap gap-x-6 gap-y-2 items-center">
        <span>
          ★ {inventory.filter((s) => s.status === "available").length} cities open
        </span>
        <span>★ {inventory.filter((s) => s.status === "sold").length} sold</span>
        <span>★ {inventory.filter((s) => s.status === "in_talks").length} in talks</span>
      </div>
    </section>
  );
}
